import React from 'react';
import { BlockContentContext } from '../../BlockContent.utils';
import { ArticleVideoBlock, Props, VideoBlock } from '../components/Video/Video';

export const VideoSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value }: Props) => <ArticleVideoBlock value={value} />;
  }
  return ({ value }: Props) => <VideoBlock value={value} />;
};
